import consoleInfo from './consoleInfo'

export const alphaPropTemplate = (component: string, prop: string) =>
  `${component} - The '${prop}' prop is in an experimental state, and is subject to breaking changes.`

const logAlphaProp = (component: string, prop: string) =>
  consoleInfo(alphaPropTemplate(component, prop))

export default logAlphaProp
